export const setGlobalSetting = (newState) => ({
  type: 'SET_GLOBAL_SETTING',
  newState,
});

export const getGlobalSettingError = () => ({
  type: 'GET_GLOBAL_SETTING_ERROR',
});
